import { isEmpty } from 'lodash';

const getOneRoleAccess = (response) => {
  if (isEmpty(response)) return;

  let operatorMenu = [];

  const menus = response?.menus.map((menu) => {
    return {
      id: menu.id,
      permissions: menu.permissions.map((permission) => {
        return permission.id;
      }),
    };
  });

  if (response?.isBackoffice) operatorMenu = menus;

  const accessType = response?.isBackoffice ? { label: 'Desktop Website', value: 'Desktop Website' } : { label: 'Mobile Website', value: 'Mobile Website' };

  return { ...response, operatorMenu, accessType };
};

export default getOneRoleAccess;
